<template>
  <div aria-labelledby="general-tab" class="tab-pane fade show active" id="general" role="tabpanel">
    <div class="row">
      <input-text v-model="fields.backend_id" :options="{ id: 'backend_id', transPrefix: `${transPrefix}.fields`, label: 'backend_id', disabled: true }"/>
      <input-text v-if="fields.dispatched_by" v-model="fields.dispatched_by" :options="{ id: 'dispatched_by', label: 'dispatched_by', disabled: true }"/>
      <select-order-status v-model="fields.order_status" :options="{ id: 'order_status', label: 'status', disabled: true }"/>
      <select-payment-types v-model="fields.payment_type" :options="{ id: 'payment_type', transPrefix: `${transPrefix}.fields`, label: 'payment_type', disabled: true }"/>
      <input-text v-if="fields.city" v-model="fields.city" :options="{ id: 'city', label: 'city', disabled: true }"/>
      <input-text v-if="fields.type" v-model="fields.type" :options="{ id: 'type', label: 'type', disabled: true }"/>
    </div>
  </div>
</template>
<script>
  export default {
    name: "PlatformsPortalOrderTabsGeneral",
    props: {
      transPrefix:{
        type: String,
        default: ''
      },
      fields: {
        type: Object,
        default: () => { }
      },
    },
    data(){
      return {
      }
    },
  };
</script>
